import { FC, useState, useEffect } from "react";
import { Grid } from "@mui/material";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { ApiStatus } from "../../types/api/status";
import { CustomBackdrop } from "../../components/common/CustomBackdrop/CustomBackdrop";
import { useRewardStudentStore } from "../../hooks/useRewardStudentStore";
import { useNavigate } from "react-router-dom";
import { RoutesMap } from "../../types";

const columns = [
  {
    type: "text",
    field: "student",
    label: "Alumno",
    format: ({ name, surname }) => `${name} ${surname}`,
  },
  {
    type: "text",
    field: "dni",
    label: "DNI",
    format: ({ dni }) => dni,
  },
  {
    type: "text",
    field: "points",
    label: "Puntos acumulados",
    format: ({ points }) => {
      const setting = {
        style: {
          margin: "0 auto",
          width: "min-content",
          padding: "5px",
          borderRadius: 10,
        },
        isSpecial: false,
        graterThan500: {
          backgroundColor: "#F43B3B",
          color: "#FFFFFF",
          fontWeight: "600",
          fontSize: "16px",
        },
        lessThan500: {
          backgroundColor: "#39E43D",
          color: "#000000",
          fontWeight: "600",
          fontSize: "16px",
        },
      };

      const style =
        points >= 500
          ? { ...setting.graterThan500, ...setting.style }
          : points >= 400
          ? { ...setting.lessThan500, ...setting.style }
          : setting.style;

      return (
        <div>
          <div style={style}>{points}</div>
        </div>
      );
    },
  },
  { type: "detail", field: "", label: "" },
];

const RewardStudentList: FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [page, setPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);

  const {
    statusRewardStudent,
    rewardStudentList,
    setSelectedRewardStudentList,
    getRewardStudentList,
    getRewardStudentListSearch,
  } = useRewardStudentStore();

  useEffect(() => {
    setLoading(true);
    getRewardStudentList().then(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const onSearch = (value) => {
    if (value.length >= 1) {
      getRewardStudentListSearch(value);
    }
    if (value.length === 0) {
      getRewardStudentList();
    }
  };

  const onDetails = (rowSelected) => {
    setSelectedRewardStudentList(rowSelected);
    navigate(RoutesMap.REWARDSTUDENTDETAIL);
  };

  return (
    <>
      {statusRewardStudent === ApiStatus.FETCHING && (
        <CustomBackdrop open={true} />
      )}
      <Grid item xs={12}>
        <CustomTable
          title={"Puntos Acumulados"}
          columns={columns}
          loading={loading}
          rows={rewardStudentList || []}
          onRowClick={() => {}}
          hasOptions
          onSearch={onSearch}
          rowsPerPage={rowsPerPage}
          page={page}
          onDetails={onDetails}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Grid>
    </>
  );
};

export default RewardStudentList;
